import {
  DASHBOARD_SECTION,
  LOAN_ACKNOWLEDGEMENT,
  CLAIMS_LISTING,
  NEW_CLAIM
} from "../constants";

export const routes = {
  home: "/",
  dashboard: "/dashboard",
  policies: "/claims",
  newClaim: "/claim/new",
  acknowledgement: "/claim/acknowledgement"
};

export const sectionTitle = {
  "/": DASHBOARD_SECTION,
  "/dashboard": DASHBOARD_SECTION,
  "/claims": CLAIMS_LISTING,
  "/claim/new": NEW_CLAIM,
  "/claim/acknowledgement": LOAN_ACKNOWLEDGEMENT,
};

export const durationMapping = {
  0: 'today',
  1: 'thisWeek',
  2: 'thisMonth'
};

export const productClaimType = {
  63: 117,
  67: 118,
  92: 119,
};
